import * as React from 'react';
export const finSvg = React.forwardRef(function finSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.667 19.33A3.333 3.333 0 0 0 28 15.94c-.03-1.827-1.56-3.276-3.387-3.276h-1.279a3.98 3.98 0 0 1-2.52-.895.134.134 0 0 1 0-.21 3.982 3.982 0 0 1 2.52-.895h1.275c1.86 0 3.405-1.497 3.392-3.357a3.309 3.309 0 0 0-3.31-3.31c-1.86-.013-3.357 1.533-3.357 3.393v1.274a3.98 3.98 0 0 1-.895 2.52.134.134 0 0 1-.21 0 3.982 3.982 0 0 1-.894-2.52V7.331a3.334 3.334 0 0 0-3.39-3.333c-1.828.03-3.277 1.56-3.277 3.388v1.278a3.98 3.98 0 0 1-.895 2.52.134.134 0 0 1-.21 0 3.982 3.982 0 0 1-.894-2.52V7.331a3.333 3.333 0 0 0-3.464-3.33 3.347 3.347 0 0 0-3.2 3.2 3.333 3.333 0 0 0 3.33 3.463h1.333c.956 0 1.832.336 2.52.895a.134.134 0 0 1 0 .21 3.98 3.98 0 0 1-2.52.895h-1.28c-1.827 0-3.357 1.449-3.387 3.277-.031 1.827 1.472 3.39 3.332 3.39h1.333c.956 0 1.833.335 2.52.895a.134.134 0 0 1 0 .209 3.98 3.98 0 0 1-2.52.895H7.333a3.333 3.333 0 0 0-3.33 3.464 3.346 3.346 0 0 0 3.2 3.2 3.333 3.333 0 0 0 3.464-3.33V23.33c0-.955.336-1.832.895-2.52a.135.135 0 0 1 .21 0c.559.688.894 1.565.894 2.52v1.279c0 1.828 1.45 3.357 3.277 3.388a3.332 3.332 0 0 0 3.39-3.333v-1.333c0-.956.336-1.832.895-2.52a.134.134 0 0 1 .21 0c.558.688.894 1.564.894 2.52v1.333a3.333 3.333 0 0 0 3.463 3.33 3.346 3.346 0 0 0 3.2-3.2 3.333 3.333 0 0 0-3.33-3.464h-1.333a3.98 3.98 0 0 1-2.52-.895.134.134 0 0 1 0-.21 3.981 3.981 0 0 1 2.52-.895h1.335Zm-9.999-8.666h2.667a3.98 3.98 0 0 1 2.52.895.134.134 0 0 1 0 .21 3.98 3.98 0 0 1-2.52.895h-2.667a3.98 3.98 0 0 1-2.52-.895.134.134 0 0 1 0-.21 3.981 3.981 0 0 1 2.52-.895Zm-4 5.333v-1.333c0-.956.337-1.833.896-2.52a.134.134 0 0 1 .21 0 3.98 3.98 0 0 1 .894 2.52v2.666a3.98 3.98 0 0 1-.895 2.52.135.135 0 0 1-.21 0 3.982 3.982 0 0 1-.894-2.52v-1.333Zm6.667 5.333h-2.667a3.98 3.98 0 0 1-2.52-.895.134.134 0 0 1 0-.21 3.981 3.981 0 0 1 2.52-.895h2.667c.956 0 1.833.336 2.52.896a.134.134 0 0 1 0 .209 3.98 3.98 0 0 1-2.52.895Zm4-5.333v1.334c0 .955-.336 1.832-.896 2.52a.134.134 0 0 1-.209 0 3.981 3.981 0 0 1-.895-2.52v-2.667c0-.956.336-1.833.895-2.52a.134.134 0 0 1 .21 0 3.98 3.98 0 0 1 .895 2.52v1.333Z',
      fill: '#111',
    }),
  );
});
finSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fin = {
  category: 'brand',
  colorable: false,
  name: 'fin',
  svg: finSvg,
};
